import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SmsOutboxResponseDto } from "../../shared/dtos/sms/SmsOutboxResponseDto";
import {
  getInitialListState,
  generateListReducers,
  ListState,
} from "../utils/listFactory";
import { ServerStatusPayload } from "../../shared/interfaces/ServerStatusPayload";

interface SmsOutboxState extends ListState<SmsOutboxResponseDto> {
  loadingSendManual: boolean;
  errorSendManual: string | null;
  serverStatus: ServerStatusPayload | null;
}

const initialState: SmsOutboxState = {
  ...getInitialListState<SmsOutboxResponseDto>(),
  loadingSendManual: false,
  errorSendManual: null,
  serverStatus: null,
};

export const smsOutboxSlice = createSlice({
  name: "smsOutbox",
  initialState,
  reducers: {
    ...generateListReducers<SmsOutboxResponseDto>(),
    setLoadingSendManual(state) {
      state.loadingSendManual = true;
      state.errorSendManual = null;
    },
    setErrorSendManual(state, action: PayloadAction<string | null>) {
      state.loadingSendManual = false;
      state.errorSendManual = action.payload;
    },
    sendManualSmsSuccess(state) {
      state.loadingSendManual = false;
    },
    setServerStatus(state, action: PayloadAction<ServerStatusPayload | null>) {
      state.serverStatus = action.payload;
    },
  },
});

export const smsOutboxActions = smsOutboxSlice.actions;
export default smsOutboxSlice.reducer;
